(async () => {
    const { Core } = await importModule('Core');
    const { $classListTemp, $toggleDisplay } = await importModule('Utils');

    const CN_ANIMATE = '!animate';

    customElements.define('cart-counter', class extends Core {

        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
        }

        render() {
            this.subscribe('cart:update', { global: true });
        }

        _cartUpdateHandler(cart) {
            this.items = +cart.getCount();
            $classListTemp(this, CN_ANIMATE);
        }

        set items(value) {
            this.textContent = value;
            $toggleDisplay(this, !!value);
        }
    })
})();